import RoomPage from "./RoomPage";

export default RoomPage;
